<template>
<header class="header">
  <a class="header-brand" href="#">
    <img src="/logo.png" alt="" width="120" height="30" class="d-inline-block align-top" >
    <!-- Silom POS -->
  </a>
</header>
</template>